import React from 'react';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  formatDateDisplayLocal,
  formatTimeDisplayLocal,
} from '@fortress-technology-solutions/fortress-component-library/utils';

export default function DateTimeDisplay({ data }) {
  const time = data?.time ?? data?.date ?? null;
  return (
    <Stack direction="column" alignItems="center">
      <Typography variant="bodySmall" color={'text.secondary'}>
        {data?.date ? formatDateDisplayLocal(data.date) : ''}
      </Typography>
      <Typography variant="bodySmall" color={'text.secondary'}>
        {time ? formatTimeDisplayLocal(time) : ''}
      </Typography>
    </Stack>
  );
}
